import { StackItem as FabricStackItem } from "@fluentui/react";

export const StackItem = FabricStackItem;
